const fullHeightEls = document.querySelectorAll('.js-full-height')

function makeFullHeight() {
    fullHeightEls.forEach(el => {
        el.style.height = height + "px";
    });
}